import { Component } from '@angular/core';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// C:/Users/bruna/Desktop/nuresp/src/app/app.component.ts